/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Get_PlusInputs */

const en_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const ar_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشترك`)
};

const de_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnieren`)
};

const es_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscríbete`)
};

const fr_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S’abonner`)
};

const it_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonati`)
};

const ja_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録する`)
};

const ko_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독`)
};

const pt_br_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assine`)
};

const ru_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписаться`)
};

const th_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครสมาชิก`)
};

const tr_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone Ol`)
};

const zh_cn_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

const zh_tw_btn_get_plus = /** @type {(inputs: Btn_Get_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Btn_Get_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_get_plus = /** @type {((inputs?: Btn_Get_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Get_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_get_plus(inputs)
	if (locale === "ar") return ar_btn_get_plus(inputs)
	if (locale === "de") return de_btn_get_plus(inputs)
	if (locale === "es") return es_btn_get_plus(inputs)
	if (locale === "fr") return fr_btn_get_plus(inputs)
	if (locale === "it") return it_btn_get_plus(inputs)
	if (locale === "ja") return ja_btn_get_plus(inputs)
	if (locale === "ko") return ko_btn_get_plus(inputs)
	if (locale === "pt_br") return pt_br_btn_get_plus(inputs)
	if (locale === "ru") return ru_btn_get_plus(inputs)
	if (locale === "th") return th_btn_get_plus(inputs)
	if (locale === "tr") return tr_btn_get_plus(inputs)
	if (locale === "zh_cn") return zh_cn_btn_get_plus(inputs)
	return zh_tw_btn_get_plus(inputs)
});